module.exports = __webpack_public_path__ + "img/Wei_Wang.b28b4377.png";